import { memo, useCallback, useEffect } from "react";
import * as signalR from "@microsoft/signalr";
import { useInvite } from "../../Context/InviteContext";

const SIGNALR_HUB_URL = "https://smbfglobal-g6bbhufugxchfncw.uksouth-01.azurewebsites.net/videoHub";

const ALERT_STYLE: React.CSSProperties = {
  zIndex: 9999,
  maxWidth: "350px",
};

function GlobalInviteListenerInner() {
  const { incomingRoomInvite, setIncomingRoomInvite } = useInvite();

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) return;

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(SIGNALR_HUB_URL, { accessTokenFactory: () => token })
      .withAutomaticReconnect()
      .build();

    connection.on("JoinRoomRequest", (roomName: string) => {
      setIncomingRoomInvite(roomName);
    });

    connection.start().catch(console.error);

    return () => {
      connection.stop();
    };
  }, [setIncomingRoomInvite]);

  const handleAcceptInvite = useCallback(() => {
    if (incomingRoomInvite) {
      window.open(
        `/video-call/${incomingRoomInvite}`,
        "_blank",
        "noopener,noreferrer"
      );
      setIncomingRoomInvite(null);
    }
  }, [incomingRoomInvite, setIncomingRoomInvite]);

  const handleRejectInvite = useCallback(() => {
    setIncomingRoomInvite(null);
  }, [setIncomingRoomInvite]);

  if (!incomingRoomInvite) return null;

  return (
    <div
      className="alert alert-info position-fixed shadow-sm rounded d-flex align-items-center top-0 end-0 m-3"
      style={ALERT_STYLE}
    >
      <div className="flex-grow-1">
        <strong>Invitation:</strong> You've been invited to join room{" "}
        <span className="fw-bold">{incomingRoomInvite}</span>
      </div>
      <div className="btn-group btn-group-sm ms-3" role="group" aria-label="Invite actions">
        <button type="button" className="btn btn-success" onClick={handleAcceptInvite}>
          Accept
        </button>
        <button type="button" className="btn btn-outline-secondary" onClick={handleRejectInvite}>
          Reject
        </button>
      </div>
    </div>
  );
}

GlobalInviteListenerInner.displayName = "GlobalInviteListener";

export const GlobalInviteListener = memo(GlobalInviteListenerInner);
